import { Link } from "react-router-dom";
import type { VisitListItem } from "@school-sales-ai/shared";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { STATUS_BADGE, STATUS_LABEL, formatVisitDateTime } from "./visit-status";
import { VisitRowActions, type VisitModalState } from "./VisitRowActions";

type Props = {
  items: VisitListItem[];
  onAction: (state: VisitModalState) => void;
};

export function VisitStatusBadge({ status }: { status: VisitListItem["status"] }): React.JSX.Element {
  return (
    <span
      className={`rounded-full px-2 py-0.5 text-[11px] font-medium ${STATUS_BADGE[status]}`}
    >
      {STATUS_LABEL[status]}
    </span>
  );
}

export function VisitsTable({ items, onAction }: Props): React.JSX.Element {
  return (
    <div className="overflow-hidden rounded-lg border border-ink-100 bg-surface shadow-sm">
      <Table>
        <TableHeader>
          <TableRow className="bg-ink-050">
            <TableHead className="text-[11px] font-semibold uppercase tracking-widest text-ink-500">
              Fecha
            </TableHead>
            <TableHead className="text-[11px] font-semibold uppercase tracking-widest text-ink-500">
              Lead
            </TableHead>
            <TableHead className="text-[11px] font-semibold uppercase tracking-widest text-ink-500">
              Asesor
            </TableHead>
            <TableHead className="text-[11px] font-semibold uppercase tracking-widest text-ink-500">
              Estado
            </TableHead>
            <TableHead className="w-10" />
          </TableRow>
        </TableHeader>
        <TableBody>
          {items.map((visit) => (
            <TableRow key={visit.id}>
              <TableCell className="text-[13px] font-medium text-ink-900 first-letter:uppercase">
                {formatVisitDateTime(visit.startsAt)}
              </TableCell>
              <TableCell>
                <Link
                  to={`/leads/${visit.leadId}`}
                  state={{ from: "/visitas" }}
                  className="text-[13px] font-medium text-moss hover:underline"
                >
                  {visit.leadName ?? visit.leadSessionRef}
                </Link>
              </TableCell>
              <TableCell className="text-[13px] text-ink-600">
                {visit.advisorName ?? "—"}
              </TableCell>
              <TableCell>
                <VisitStatusBadge status={visit.status} />
              </TableCell>
              <TableCell className="text-right">
                <VisitRowActions visit={visit} onAction={onAction} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
